<template>
  <router-link :to="{ name: ROUTE_NAMES.HOME }">
    <v-img
      :src="LogoImage"
      class="pointer"
      alt="Szlachetna Paczka"
      aspect-ratio="1"
      position="center"
      :width="width"
      :height="height"
    />
  </router-link>
</template>

<script setup lang="ts">
// @TODO: After upgrade to Webpack5/Vite, create base component for images to convert images to webp/avif based on path
import LogoImage from '@/assets/images/logo.png?format=webp&width=132&height=132'
import ROUTE_NAMES from '@/constants/routeNames'

type Props = {
  width?: number
  height?: number
}

withDefaults(defineProps<Props>(), {
  width: 132,
  height: 132
})
</script>
